import AccountsService from '@/services/apiRequests/accounts.service';

export default {
    namespaced: true,
    state: {
        accounts: null,
        rowCount: 0,
        filterOptions: {
            sum_debt: null,
            person_name: null,
            isServiceConnected: null,
            account_number: null,
            selectedDistrictRid: null,
            notice_status_type_rid: null,
            selectedAddress: {}
        },
        notices: null,
        noticesLoading: false,
        noticesLength: null,
        noticesPaginationOptions: {
            page: 0,
            itemsPerPage: 10
        },
        noticesFilterOptions: {
            main_dolg: null,
            name: null,
            serial_number: null,
            selectedAddress: {},
            doc_create_date: null,
            doc_delivery_date: null,
            doc_signed: null
        },
        noticeDetails: {}
    },
    getters: {
        getAccounts(state) {
            return state.accounts;
        },
        getRowCount(state) {
            return state.rowCount;
        },
        getNotices(state) {
            return state.notices;
        },
        getNoticesLoading(state) {
            return state.noticesLoading;
        },
        getNoticesLength(state) {
            return state.noticesLength;
        },
        getNoticesPaginationOptions(state) {
            return state.noticesPaginationOptions;
        },
        getNoticeDetails(state) {
            return state.noticeDetails;
        }
    },
    mutations: {
        setAccounts(state, data) {
            state.accounts = data;
        },
        setRowCount(state, rowCount) {
            state.rowCount = rowCount;
        },
        setFilterOptions(state, filterOptions) {
            state.filterOptions = filterOptions;
        },
        setNotices(state, notices) {
            state.notices = notices;
        },
        setNoticesLoading(state, isLoading) {
            state.noticesLoading = isLoading;
        },
        setNoticesLength(state, length) {
            state.noticesLength = length;
        },
        setNoticesPage(state, page) {
            state.noticesPaginationOptions.page = page;
        },
        setNoticesFilterOptions(state, filterOptions) {
            state.noticesFilterOptions = filterOptions;
        },
        setNoticeDetails(state, details) {
            state.noticeDetails = details;
        }
    },
    actions: {
        async getAccounts({ state, commit }, { currentItem, itemsPerPage }) {
            const is_connected = state.filterOptions.isServiceConnected == 1 ? true : state.filterOptions.isServiceConnected == 0 ? false : null;
            const payloadData = {
                currentItem: currentItem,
                itemsPerPage: itemsPerPage,
                iWhereOrderLocale: {
                    where: [
                        { field: 'sum_debt', value: state.filterOptions.sum_debt },
                        { field: 'account_number', value: state.filterOptions.account_number },
                        { field: 'person_name', value: state.filterOptions.person_name },
                        { field: 'address_rid', value: state.filterOptions.selectedAddress.record_id },
                        { field: 'district_rid', value: state.filterOptions.selectedDistrictRid },
                        { field: 'notice_status_type_rid', value: state.filterOptions.notice_status_type_rid },
                        { field: 'is_connected', value: is_connected }
                    ]
                }
            };
            const response = await AccountsService.getAccounts(payloadData);
            if (response) {
                commit('setAccounts', response.data['ahs_accounts']);
                commit('setRowCount', response.data.pagination['row_count']);
            }
        },
        setFilterOptions({ commit }, filterOptions) {
            commit('setFilterOptions', { ...filterOptions });
        },
        async getPreTrialNotices({ commit, state }) {
            const { page, itemsPerPage } = state.noticesPaginationOptions;
            const { doc_create_date, doc_delivery_date, doc_signed, main_dolg, name, selectedAddress, serial_number } = state.noticesFilterOptions;
            const is_signed = doc_signed == 1 ? true : doc_signed == 0 ? false : null;
            const payloadData = {
                currentItem: page,
                itemsPerPage,
                iWhereOrderLocale: {
                    where: [
                        { field: 'consumption_category', value: null },
                        { field: 'account_number', value: serial_number },
                        { field: 'address_rid', value: selectedAddress.record_id },
                        { field: 'person_name', value: name },
                        { field: 'doc_create_date', value: doc_create_date },
                        { field: 'main_dolg', value: main_dolg },
                        { field: 'doc_delivery_date', value: doc_delivery_date },
                        { field: 'doc_signed', value: is_signed }
                    ]
                }
            };
            commit('setNoticesLoading', true);
            const response = await AccountsService.getPreTrialNotices(payloadData);
            const notices = response.data['ahs_accounts_PreTrialNotices'] || [];
            const noticesLength = response.data.pagination['row_count'];
            commit('setNoticesLength', noticesLength);
            const changedNotices = notices.map(notice => {
                const { account_operation_action_rid, account_number, person_name, ...rest } = notice;
                return {
                    ...rest,
                    id: account_operation_action_rid,
                    serial_number: account_number,
                    name___ru: person_name,
                    name___kz: person_name
                };
            });
            commit('setNotices', changedNotices);
            commit('setNoticesLoading', false);
        },
        setNoticesFilterOptions({ state, commit }, filterOptions) {
            commit('setNoticesFilterOptions', filterOptions);
            commit('setNoticesPage', 0);
        },
        async getNoticePDF({ state }, selectedPreTrials) {
            const response = await AccountsService.getPreTrialNoticePDF(selectedPreTrials);

            const base64EncodedPDF = response.data;
            const newWindow = window.open();

            newWindow.document.write('<iframe width="100%" height="100%" src="data:application/pdf;base64,' + base64EncodedPDF + '"></iframe>');

            newWindow.onload = function() {
                newWindow.print();
            };
        },
        async setPreTrialNoticeDetails({ state, commit }, id) {
            const response = await AccountsService.getPreTrialNoticeDetails(id);

            const keyMapping = {
                account_number: 'serial_number',
                person_name: 'name',
                account_operation_action_guid: 'guid',
                account_operation_action_rid: 'id'
            };

            const updatedObject = Object.fromEntries(Object.entries(response.data).map(([key, value]) => [keyMapping[key] || key, value]));
            commit('setNoticeDetails', updatedObject);
        }
    }
};
